<template>
    <div class="product-link">
        <h2 class="subtitle">Items</h2>
        <div>
            <div v-if="productItems.length < 1">
                No items attached to this product
                <br/>
            </div>
            <div v-for="item in productItems">
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <input v-if="editingItem === item.id"
                                   type="number"
                                   min="1"
                                   class="input item-count-input"
                                   :value="item.count"
                                   @input="editItemCount = $event.target.value">
                            <strong v-if="editingItem !== item.id">{{ item.count }} x</strong>
                        </div>
                        <div class="level-item">
                            <router-link :to="{ name: 'item', params: {id: item.id}}">
                                {{ item.name }}
                            </router-link>
                        </div>
                        <div class="level-item">
                            -
                            &nbsp;
                            <span v-if="editingItem !== item.id">
                                <a @click="edit(item)">Edit</a>
                                &nbsp;
                                <a class="delete" @click="remove(item)"></a>
                            </span>
                            <span v-else>
                                <button type="button" class="button is-primary" @click="update(item)">Save</button>
                                <button type="button" class="button" @click="stopEdit()">Cancel</button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br/>
        <div v-if="!adding">
            <a class="button is-small" @click="adding = true">Add item...</a>
        </div>
        <div v-if="adding">
            <p class="control">
                <label class="label">How many?</label>
                <input type="number"
                       min="1"
                       class="input item-count-input"
                       :value="newItemCount"
                       @input="newItemCount = $event.target.value">
                <span class="select">
                    <select name="item-add" @change="add($event.target.value)">
                        <option>Select an item...</option>
                        <option v-for="item in availableItems" :value="item.id">{{ item.name }}</option>
                    </select>
                </span>
                <button type="button" class="button" @click="adding = false">Cancel</button>
            </p>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import {CREATE_PRODUCT_ITEM, UPDATE_PRODUCT_ITEM, DELETE_PRODUCT_ITEM} from "../../store/mutation-types"
    export default {
        props: ['productId'],
        data() {
            return {
                adding: false,
                newItemCount: 1,
                editingItem: false,
                editItemCount: 1,
            }
        },
        computed: Object.assign({}, mapGetters(['items']), {
            availableItems () {
                let items = this.$store.state.products.product_items.filter(item => item.product_id === this.productId)
                let ids   = []
                for (let item in items) {
                    ids.push(items[item].item_id)
                }
                return this.items.filter(item => ids.indexOf(item.id) === -1).sort((a, b) => {
                    a       = a.name
                    b       = b.name
                    let reA = /[^a-zA-Z]/g;
                    let reN = /[^0-9]/g;
                    let aA  = a.replace(reA, "");
                    let bA  = b.replace(reA, "");
                    if (aA === bA) {
                        let aN = parseInt(a.replace(reN, ""), 10);
                        let bN = parseInt(b.replace(reN, ""), 10);
                        return aN === bN ? 0 : aN > bN ? 1 : -1;
                    } else {
                        return aA > bA ? 1 : -1;
                    }
                })
            },
            productItems () {
                let items = this.$store.state.products.product_items.filter(item => item.product_id === this.productId)
                let ids   = []
                for (let item in items) {
                    ids.push(items[item].item_id)
                }
                return this.items.filter(item => ids.indexOf(item.id) !== -1).map(item => {
                    let itemLink = items.find(c => c.item_id === item.id);
                    return Object.assign(item, {
                        link_id: itemLink.id,
                        count: itemLink.count,
                    })
                })
            }
        }),
        methods: {
            edit(item) {
                this.editingItem   = item.id
                this.editItemCount = item.count
            },
            stopEdit() {
                this.editingItem = false
            },
            add(item) {
                this.$store.dispatch(CREATE_PRODUCT_ITEM, {
                    product_id: this.productId,
                    item_id: item,
                    count: this.newItemCount
                })
                this.adding = false
            },
            update(item) {
                this.$store.dispatch(UPDATE_PRODUCT_ITEM, {
                    id: item.link_id,
                    product_id: this.productId,
                    item_id: item.id,
                    count: this.editItemCount,
                })
                this.adding      = false
                this.editingItem = false;
            },
            remove(item) {
                this.$store.dispatch(DELETE_PRODUCT_ITEM, {
                    id: item.link_id,
                    product_id: this.productId,
                    item_id: item.id,
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ProductItems.vue?bb97d3e2